var exports = {
  "vK": "TableGameResult.module__banner___b1pWQ1",
  "DD": "TableGameResult.module__title___b1pWQ1",
  "_0": "TableGameResult.module__detail___b1pWQ1",
  "ad": "TableGameResult.module__ranked___b1pWQ1",
};

module.exports = exports;
